/*
 * @Description:
 * @Author: Rfan
 * @Date: 2020-11-05 10:21:18
 * @LastEditTime: 2021-12-07 10:05:47
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Service from '../views/Service.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/service'
  },
  {
    path: '/service',
    name: 'service',
    component: Service,
    meta: {
      title: '熊猫绘画服务协议'
    }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () =>
      import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue'),
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/permissions',
    name: 'Permissions',
    component: () =>
      import(/* webpackChunkName: "Permissions" */ '../views/Permissions.vue'),
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/member',
    name: 'member',
    component: () =>
      import(/* webpackChunkName: "member" */ '../views/Member.vue'),
    meta: {
      title: '会员协议'
    }
  },
  {
    path: '/term',
    name: 'term',
    component: () =>
      import(/* webpackChunkName: "term" */ '../views/Term.vue'),
    meta: {
      title: '自动续费规则'
    }
  },
  {
    path: '/face',
    name: 'face',
    component: () => import(/* webpackChunkName: "face" */ '../views/Face.vue'),
    meta: {
      title: '人脸验证服务协议'
    }
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (window.location.href.indexOf('happycode.xyz') < 0) {
    if (to.meta.title) {
      document.title = to.meta.title
    }

    next()
  }
})

export default router
